export default {"src":"/_next/static/media/cozumortagi-big.0ed60ba1.svg","height":56,"width":525};